/**
 * Account settings → Notifications: a member's own email preferences.
 *
 *   privateData.disableEventReminders   true turns episode reminders off
 *   privateData.extraEpisodeReminders   true adds the 24 hours and 15 minutes
 *                                       reminders for episodes they reserved
 *
 * Read by server/services/eventReminders.js. The values live on the member's
 * own profile, so they are written straight through the member's session;
 * the page reads them from the current user.
 */
import { storableError } from '../../util/errors';
import { fetchCurrentUser } from '../../ducks/user.duck';

// ================ Action types ================ //

export const UPDATE_PREF_REQUEST = 'app/AccountNotificationsPage/UPDATE_PREF_REQUEST';
export const UPDATE_PREF_SUCCESS = 'app/AccountNotificationsPage/UPDATE_PREF_SUCCESS';
export const UPDATE_PREF_ERROR = 'app/AccountNotificationsPage/UPDATE_PREF_ERROR';

// ================ Reducer ================ //

const initialState = {
  savingKey: null,
  updateError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_PREF_REQUEST:
      return { ...state, savingKey: payload.key, updateError: null };
    case UPDATE_PREF_SUCCESS:
      return { ...state, savingKey: null };
    case UPDATE_PREF_ERROR:
      return { ...state, savingKey: null, updateError: payload };
    default:
      return state;
  }
}

// ================ Thunks ================ //

export const updateNotificationPref = (key, value) => (dispatch, getState, sdk) => {
  dispatch({ type: UPDATE_PREF_REQUEST, payload: { key } });
  return sdk.currentUser
    .updateProfile({ privateData: { [key]: value } })
    .then(() => dispatch(fetchCurrentUser()))
    .then(() => dispatch({ type: UPDATE_PREF_SUCCESS }))
    .catch(e => dispatch({ type: UPDATE_PREF_ERROR, payload: storableError(e), error: true }));
};
